module.exports = __webpack_public_path__ + "img/login-information-sheetC.04fa6b34.png";